import safeStorage from '../../utils/safeStorage';

export const TAG_OUT_CODE_STORAGE_KEY = 'yona.pending_tag_out_code';

export function normalizeTagOutCode(raw) {
  const compact = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (compact.startsWith('TAG12') && compact.length > 5) {
    return `TAG12-${compact.slice(5)}`;
  }
  if (compact.startsWith('TAG3') && compact.length > 4) {
    return `TAG3-${compact.slice(4)}`;
  }
  return '';
}

export function savePendingTagOutCode(raw) {
  const code = normalizeTagOutCode(raw);
  if (!code) return '';
  safeStorage.setItem(TAG_OUT_CODE_STORAGE_KEY, code);
  return code;
}

export function peekPendingTagOutCode() {
  return normalizeTagOutCode(safeStorage.getItem(TAG_OUT_CODE_STORAGE_KEY) || '');
}

export function clearPendingTagOutCode() {
  safeStorage.removeItem(TAG_OUT_CODE_STORAGE_KEY);
}

export function captureTagOutCodeFromSearch(search) {
  const query = String(search || '');
  const params = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);
  return savePendingTagOutCode(params.get('code'));
}

export function postAuthPath({ fallback = '/maps' } = {}) {
  return peekPendingTagOutCode() ? '/profile/account' : fallback;
}

export function tagOutRedeemError(err) {
  const data = err?.response?.data || {};
  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
  return 'Could not apply that Tag Out code.';
}
